'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type * as React from 'react';
import { useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { InputField } from '@/components/ui/input-field';
import { ClipsButton } from './clips-button';
import { EarnCard } from './earn-card';
import { useRewardsTips } from './info-tip';
interface ClipCardProps {
  capsRemaining?: number | undefined;
  referralLink?: string | undefined;
  onSubmit: (value: string) => void;
  busy?: boolean | undefined;
}
const CLIP_DAILY_CAP = 5;
export function ClipCard(t0) {
  const $ = _c(38);
  const {
    capsRemaining,
    referralLink,
    onSubmit,
    busy
  } = t0;
  const t = useTranslations("rewards");
  const tips = useRewardsTips();
  const [value, setValue] = useState("");
  const used = CLIP_DAILY_CAP - (capsRemaining ?? CLIP_DAILY_CAP);
  const completed = used >= CLIP_DAILY_CAP;
  let t1;
  if ($[0] !== completed || $[1] !== onSubmit || $[2] !== value) {
    t1 = () => {
      if (completed) {
        return;
      }
      const trimmed = value.trim();
      if (trimmed === "") {
        return;
      }
      onSubmit(trimmed);
      setValue("");
    };
    $[0] = completed;
    $[1] = onSubmit;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const submit = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t("clip.title");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = tips.clip;
  let t4;
  if ($[6] !== referralLink) {
    t4 = <ClipsButton referralLink={referralLink} />;
    $[6] = referralLink;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("clip.pill");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("clip.description");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = used / CLIP_DAILY_CAP * 100;
  const t8 = `${used}/${CLIP_DAILY_CAP}`;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e => setValue(e.target.value);
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t) {
    t10 = t("clip.placeholder");
    $[13] = t;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== completed || $[16] !== t10 || $[17] !== value) {
    t11 = <InputField fullWidth={true} containerClassName="flex-1" value={value} onChange={t9} placeholder={t10} disabled={completed} />;
    $[15] = completed;
    $[16] = t10;
    $[17] = value;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = busy || completed;
  let t13;
  if ($[19] !== t) {
    t13 = t("clip.submit");
    $[19] = t;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== busy || $[22] !== submit || $[23] !== t12 || $[24] !== t13) {
    t14 = <AnimatedButton variant="secondary" data-testid="submit-clip" onClick={submit} disabled={t12} loading={busy}>{t13}</AnimatedButton>;
    $[21] = busy;
    $[22] = submit;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t14) {
    t15 = <div className="flex items-center gap-2">{t11}{t14}</div>;
    $[26] = t11;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t2 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== tips.clip) {
    t16 = <EarnCard data-testid="clip-card" title={t2} tip={t3} titleAdornment={t4} points={t5} description={t6} progress={t7} progressLabel={t8}>{t15}</EarnCard>;
    $[29] = t15;
    $[30] = t2;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = tips.clip;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}